"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLocalSearch = void 0;
var _react = require("react");
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/**
 * 
 * @param {Object} items the list of items to be searched
 * @param {string} itemAccessor the accessor to access the label of item 
 * @returns {Object} the function to set search keyword and the result
 */
var useLocalSearch = exports.useLocalSearch = function useLocalSearch() {
  var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var itemAccessor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'label';
  var transformItem = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (result) {
    return result;
  };
  var _useState = (0, _react.useState)(''),
    _useState2 = _slicedToArray(_useState, 2),
    keyword = _useState2[0],
    setSearchKeyword = _useState2[1];
  var searchResults = (0, _react.useMemo)(function () {
    if ((keyword === null || keyword === void 0 ? void 0 : keyword.length) < 3) {
      return [];
    }
    var normalizeText = function normalizeText(text) {
      var _text$toLowerCase;
      return (_text$toLowerCase = text === null || text === void 0 ? void 0 : text.toLowerCase()) !== null && _text$toLowerCase !== void 0 ? _text$toLowerCase : '';
    };
    var filtered = items.filter(function (item) {
      return normalizeText(item[itemAccessor]).includes(normalizeText(keyword));
    }).sort(function (firstItem, secondItem) {
      return firstItem[itemAccessor].localeCompare(secondItem[itemAccessor]);
    });
    return filtered.length > 10 ? filtered.slice(0, 10) : filtered;
  }, [keyword, items, itemAccessor]);
  return {
    setSearchKeyword: setSearchKeyword,
    searchResults: searchResults.map(function (item) {
      return transformItem(item);
    })
  };
};